
import * as React from 'react';
import GeneralView from './general.view';
import { ContextService } from 'src/core/services/context.service';
import { CardController } from 'src/app/shared/card.controller';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { ProductServiceTypeDataService } from 'src/app/products/product-service-types/list/product-service-type-list.data';

interface IGeneralControllerProps extends ComponentViewProps<QuoteItineraryGroupItem> {
	model: QuoteItineraryGroupSummary,
	mode: ControlMode;
	contextService: ContextService;

	itinerary: TourItineraryItem;
	defaultLanguage: string;
}

interface IGeneralControllerState {

}

@observer
export default class GeneralController extends React.Component<IGeneralControllerProps, IGeneralControllerState>{

	@observable
	serviceTypeDataService: ProductServiceTypeDataService;

	componentDidMount() {
		this.loadServiceType();
	}

	loadServiceType = async () => {
		this.serviceTypeDataService = ProductServiceTypeDataService.make(this.props.contextService);

		this.serviceTypeDataService.addFilter('id', 'eq', this.props.itinerary.productServiceTypeId);
		this.serviceTypeDataService.addSorting('id', 'asc');

		this.serviceTypeDataService.load(query => query);
	}

	render() {

		if (!this.serviceTypeDataService || !this.serviceTypeDataService.item)
			return null;

		return (
			<CardController
				className="card-borderless"
				mode={this.props.mode}>
				<GeneralView
					service={this.serviceTypeDataService.item}
					{...this.props}/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/parts/general.controller.tsx